import { useMemo } from 'react';
import { KIOSK_SESSION_KEY } from './useKioskIdleReset';

export default function useIsKioskMode() {
  return useMemo(() => {
    try {
      return window.sessionStorage.getItem(KIOSK_SESSION_KEY) === 'true';
    } catch (error) {
      return false;
    }
  }, []);
}
